import { render, staticRenderFns } from "./OrdenacaoDragnDrop.vue?vue&type=template&id=6e0fcf14&"
import script from "./OrdenacaoDragnDrop.vue?vue&type=script&lang=js&"
export * from "./OrdenacaoDragnDrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports